import { LoadState } from "@redotech/react-util/load";
import { CustomerActivityFilterOptions } from "@redotech/redo-customer-common/customer-activity/customer-activity-filters";
import { CustomerEvent } from "@redotech/redo-customer-event-common/customer-event-definition";
import { ConversationTimelineEvent } from "@redotech/redo-model/conversation-timeline";
import { Order } from "@redotech/redo-model/order";
import { MerchantAppReturn, ReturnType } from "@redotech/redo-model/return";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { ComponentType, createContext } from "react";

export enum EventType {
  CONVERSATION = "conversation",
  CUSTOMER = "customer",
}

interface ConversationEventWrapper {
  type: EventType.CONVERSATION;
  event: ConversationTimelineEvent;
}

interface CustomerEventWrapper {
  type: EventType.CUSTOMER;
  event: CustomerEvent;
}

export type CombinedEvent = CustomerEventWrapper | ConversationEventWrapper;

export interface ActionPanelComponentContext {
  ActivityPanel: ComponentType<{
    headerText?: string;
    conversationActivityLoad: LoadState<CombinedEvent[]>;
    customerActivityFilterOptions: CustomerActivityFilterOptions | undefined;
    setCustomerActivityFilterOptions: (
      options: CustomerActivityFilterOptions | undefined,
    ) => void;
  }>;
  DuplicateOrderModal: ComponentType<{
    open: boolean;
    setOpen: (open: boolean) => void;
    order: Order;
  }>;
  MerchantCreateReturnModal: ComponentType<{
    open: boolean;
    setOpen(open: boolean): void;
    returnType: ReturnTypeEnum;
    relocationInfo: {
      preselectedOrder: Order;
      currentView?: string;
      returnQueryParams?: { [key: string]: string };
    };
  }>;
  OrderDetails: ComponentType<{
    order: Order;
    collapsible?: boolean;
    setCancelOrderModalOpen?(open: boolean): void;
    setCreateClaimModalOpen?(open: boolean): void;
    setCreateType?(type: ReturnType): void;
    setDuplicateOrderModalOpen?(open: boolean): void;
    setEditOrderModalOpen?(open: boolean): void;
    setOrderNeedingAction?(order: Order): void;
    setRefundOrderModalOpen?(open: boolean): void;
  }>;
  ReturnDetails: ComponentType<{
    returnItem: MerchantAppReturn;
    reloadReturns(): void;
  }>;
}

export const ActionPanelComponentContext =
  createContext<ActionPanelComponentContext>({
    ActivityPanel: () => null,
    DuplicateOrderModal: () => null,
    MerchantCreateReturnModal: () => null,
    OrderDetails: () => null,
    ReturnDetails: () => null,
  });
